import { render, staticRenderFns } from "./OptionDepartment.vue?vue&type=template&id=3ec3816a&scoped=true&"
import script from "./OptionDepartment.vue?vue&type=script&lang=ts&"
export * from "./OptionDepartment.vue?vue&type=script&lang=ts&"
import style0 from "./OptionDepartment.vue?vue&type=style&index=0&id=3ec3816a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec3816a",
  null
  
)

export default component.exports